// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.header[data-v-58d19944]{ border-bottom:1px solid var(--main-gray-2);\n}\n.header .w-col[data-v-58d19944]{ padding-top: 0px; padding-bottom: 0px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
